import { render, staticRenderFns } from "./DocumentCommentListing.vue?vue&type=template&id=6be088df"
import script from "./DocumentCommentListing.vue?vue&type=script&lang=js"
export * from "./DocumentCommentListing.vue?vue&type=script&lang=js"
import style0 from "./DocumentCommentListing.vue?vue&type=style&index=0&id=6be088df&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports